<!-- 合作机构人员 -->
<template>
    <div class="cooperate">
        <el-form ref="form" :model="form" inline class="form"  label-width="80px">
            <el-form-item label="工号">
                <el-input v-model="form.jobNumber" placeholder="请输入工号"></el-input>
            </el-form-item>
            <el-form-item label="客户名称">
                <el-input v-model="form.customerName" placeholder="请输入客户名称"></el-input>
            </el-form-item>
            <el-form-item label="人员姓名">
                <el-input  placeholder="请输入人员姓名"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="form.condition" placeholder="请选择" :clearable="true">
                    <el-option
                  v-for="item in form.conditionChoose"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" style="margin-left: 28px;">
                <el-button size="small" style="background: #18BC9C;color: #FFFFFF;" @click="query">
                    查询
                </el-button>
                <el-button size="small" style="background: #FAFAFA;color: #666666;" @click="empty">
                    重置
                </el-button>
            </el-form-item>
        </el-form>
        <div class="" style="margin-left:22px ;">
            <el-button size="small" icon="el-icon-refresh" style="background-color: #2C3E50; border-radius: 3px;"
                @click="refresh">
                <!-- 刷新 -->
            </el-button>
            <el-button size="small" icon="el-icon-plus" style="background: #18BC9C;color: #FFFFFF;"
                 @click="newlyAdded">
                新增
            </el-button>
            <el-button size="small" class="daochu">
                导出
            </el-button>
        </div>
        <!-- 表格部分 -->
        <el-table :data="tableData"  border stripe style="width:97.9%;flex: 1;" height="650" id="out-table">
            <!-- 复选按钮 -->
            <el-table-column type="selection" align="center" width="50">
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center" width="80">
                <template slot-scope="scope">
                    <span v-if="scope.row.status==1">在职</span>
                    <span v-else-if="scope.row.status==2">新人</span>
                    <span v-else-if="scope.row.status==3">兼职</span>
                    <span v-else="scope.row.status==4">离职</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="客户名称" align="center" >
            </el-table-column>
            <el-table-column prop="number" label="工号" align="center" >
            </el-table-column>
            <el-table-column prop="realname" label="人员姓名" align="center" >
            </el-table-column>
            <el-table-column prop="englishname" label="英文名字" align="center" >
            </el-table-column>
            <el-table-column prop="attr1" label="客户主责" align="center" >
            </el-table-column>
            <el-table-column prop="username" label="登录账号" align="center" >
            </el-table-column>
            <el-table-column prop="end_time" label="有效截止日期" align="center" width="200">
            </el-table-column>
            <el-table-column prop="department" label="所在部门" align="center" >
            </el-table-column>
            <el-table-column prop="" label="操作"  align="center" width="200">
                <template slot-scope="scope">
                    <el-button icon="el-icon-edit" size="mini" style="background: #18BC9C;color:#FFFFFF;" @click="edit(scope.row.id)">
                        编辑
                    </el-button>
                    <el-button type="danger" icon="el-icon-delete" size="mini" @click="close(scope.$index, scope.row.id)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-sizes="[20,50, 100,200,500,1000]" :page-size="10" background
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
</template>

<script>
    export default{
        data() {
            return{
                form: {
                  jobNumber: "", //工号
                  customerName:"",//客户名称
                  personnelName:"",//人员姓名
                  conditionChoose:[
                      {label:"在职",value:"1"},
                      {label:"新人",value:"2"},
                      {label:"兼职",value:"3"},
                      {label:"离职",value:"4"},
                  ],//状态选择
                  condition:""//状态
              }, 
                tableData: [],
               currentPage: 1,
			   currentLimit: 20,
               total: 0,
            }
        },
        created() {
            this.getList()
        },
        activated() {
           // console.log(1); 
           this.getList()
        },
        methods:{
            empty(){//重置
                this.form.jobNumber="", //工号
                this.form.customerName="",//客户名称
                this.form.personnelName="",//人员姓名
                this.form.condition=""//状态
                this.getList()
            },
        	getList() {
        		this.$request({url: '/api/cooperation/list', method: 'POST', data: {
        			page: this.currentPage,
        			limit: this.currentLimit,
        			number: this.form.jobNumber,
        			name: this.form.customerName,
					realname: this.form.personnelName,
        			status: this.form.condition
        		}}).then(res => {
        			this.tableData = res.data.list
        			this.total =res.data.count
        		})
        	},
            query(){//查询
                this.currentPage=1
                this.getList()
            },
            handleSizeChange(val) {
        		this.currentLimit = val
        		this.getList()
            },
            handleCurrentChange(val) {
                this.currentPage = val
        		this.getList()
            },
            // 刷新
            refresh() {
                this.$router.push({
                    path: "/home/newpage", //空页面路由
                    query: {
                        path: this.$route.path
                    }
                })
            },
            newlyAdded() { //新增
                this.$router.push({
                    path: "addCooperate"
                })
            },
            edit(id) { //编辑
                this.$router.push({
                    path: "editCooperate",
					query: {id: id}
                })
            },
			close(index, id){
				var that = this
				this.$confirm('是否删除此条记录?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					that.$request({url: '/api/cooperation/del', method: 'POST', data: {id}}).then(res => {
						if(res.code == 1) {
							that.$message({
							  message: res.msg,
							  type: 'success'
							});
							that.tableData.splice(index, 1) 
						}
					})
				})
			}
        }
    }
</script>

<style scoped="scoped">
    .cooperate{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    /* 查询部分 */
    .form {
         padding-top: 34px;
    }
    .form ::v-deep .el-input__inner {
        width: 276px;
        height: 37px;
    }
    ::v-deep .el-form-item__label {
        color: #000000;
    }
    /* 按钮 */
    ::v-deep .el-icon-refresh {
        font-weight: bold !important;
        color: #FFFFFF;
    }
    
    ::v-deep .el-icon-plus {
        font-weight: bold !important;
    }
    
    ::v-deep .el-icon-download {
        font-weight: bold !important;
    }
    .daochu{
        padding-left: 30px;
        background: url(../../assets/export.png) 8px 5px no-repeat #FF7300;
        color: #FFFFFF;
    }
    /* 表格部分 */
    .el-table {
        margin: 20px;
    }
    ::v-deep .el-table__cell {
        color: #000;
        padding: 0;
        height: 30px;
    }
    /* 分页 */
    .el-pagination {
        margin: 20px;
        margin-top: 0px;
    }
    
    ::v-deep.el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #2C3E50 !important;
    }
</style>
